import { useState } from "react";
import { X } from "lucide-react";

import { cn } from "@/lib/utils";
import { useComunicadosSistemaVigentes } from "@/hooks/comunicados/useComunicadosSistemaVigentes";
import { NIVEL_CONFIG } from "./comunicado-nivel";
import { ComunicadoBarraConteudo } from "./comunicado-superficies";
import { ComunicadoSistemaDialog } from "./ComunicadoSistemaDialog";

/** Barra fina no topo (abaixo da EnvironmentBar). Mostra só o topo da fila. */
export function ComunicadoSistemaBar() {
  const { topo, total, dispensar } = useComunicadosSistemaVigentes();
  const [aberto, setAberto] = useState(false);

  if (!topo) return null;

  const config = NIVEL_CONFIG[topo.nivel];
  const outros = total - 1;

  return (
    <>
      <div className={cn("flex h-9 items-center gap-2 border-b px-4 md:px-6", config.surface)}>
        <button
          type="button"
          onClick={() => setAberto(true)}
          className="flex min-w-0 flex-1 items-center gap-2 text-left"
        >
          <ComunicadoBarraConteudo comunicado={topo} />
        </button>

        {outros > 0 && (
          <span className="shrink-0 rounded-full border px-2 py-0.5 text-[11px] font-medium opacity-90">
            +{outros}
          </span>
        )}

        {topo.exigeAceite ? (
          // Crítico não é dispensável: só abre o dialog para o "Li e aceito".
          <button
            type="button"
            onClick={() => setAberto(true)}
            className="shrink-0 rounded-md px-2 py-0.5 text-[12px] font-medium underline underline-offset-2 opacity-90 hover:opacity-100"
          >
            Ver comunicado
          </button>
        ) : (
          <button
            type="button"
            onClick={() => dispensar(topo.id)}
            aria-label="Dispensar comunicado"
            className="shrink-0 opacity-70 transition-opacity hover:opacity-100"
          >
            <X className="h-4 w-4" />
          </button>
        )}
      </div>

      <ComunicadoSistemaDialog comunicado={aberto ? topo : null} onOpenChange={setAberto} />
    </>
  );
}
